<div class="dashboard-page">
  <div class="header-banner">
     <app-navbar></app-navbar>
  </div>

  <div class="dashboard-container">

    <!-- ─── Header ─────────────────────────────────────────────────── -->
    <div class="header-section">
      <div class="header-left">
        <h1 class="dashboard-title">
          Homepage <span class="dashboard-subtitle">Peer-to-Peer Solar Energy Transaction</span>
        </h1>
      </div>

      <div class="header-right">
        <div class="date-picker-badge">
          <button class="nav-btn" (click)="prevDate()">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" stroke-width="3"
                 stroke-linecap="round" stroke-linejoin="round">
              <path d="M15 18l-6-6 6-6"/>
            </svg>
          </button>

          <div class="date-display" (click)="picker.open()" style="cursor: pointer;">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" stroke-width="2.2"
                 stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
              <line x1="16" y1="2" x2="16" y2="6"/>
              <line x1="8" y1="2" x2="8" y2="6"/>
              <line x1="3" y1="10" x2="21" y2="10"/>
              <path d="M8 14h.01M12 14h.01M16 14h.01M8 18h.01M12 18h.01M16 18h.01"/>
            </svg>
            <span>As of {{ displayDate }}</span>
            <input matInput [matDatepicker]="picker" 
                   [value]="currentDate"
                   (dateChange)="onDateChange($event)"
                   style="position: absolute; opacity: 0; width: 0; height: 0; pointer-events: none;">
            <mat-datepicker #picker panelClass="premium-calendar"></mat-datepicker>
          </div>

          <button class="nav-btn" (click)="nextDate()" [disabled]="selectedDate >= today">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" stroke-width="3"
                 stroke-linecap="round" stroke-linejoin="round">
              <path d="M9 18l6-6-6-6"/>
            </svg>
          </button>
        </div>
      </div>
    </div>

    <!-- ─── Center Messages (Loading / Error) ─── -->
    <div class="center-message-wrapper" *ngIf="loading">
      <div class="center-message">
        <div class="spinner"></div>
      </div>
    </div>

    <div class="center-message-wrapper" *ngIf="!loading && error">
      <div class="center-message">
        <div>
          <strong>{{ error }}</strong>
          <div style="margin-top: 12px">
            <button class="retry-btn" (click)="loadForSelectedDate()">Retry</button>
          </div>
        </div>
      </div>
    </div>

    <!-- ─── Dashboard Content ─── -->
    <ng-container *ngIf="!loading && !error">
      <!-- ─── Top Stats ───────────────────────────────────────────────── -->
      <div class="top-stats-grid">
        <div class="stat-card">
          <div class="card-icon blue-icon">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none"
                 stroke="#2563eb" stroke-width="1.8"
                 stroke-linecap="round" stroke-linejoin="round">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
              <circle cx="9" cy="7" r="4"/>
              <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
              <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
            </svg>
          </div>
          <div class="card-info">
            <div class="card-label">TOTAL PARTICIPANTS</div>
            <div class="card-value">{{ display(topStats.totalParticipants) }}</div>
          </div>
        </div>

        <div class="stat-card">
          <div class="card-icon orange-icon">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="#f97316" stroke="none">
              <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/>
            </svg>
          </div>
          <div class="card-info">
            <div class="card-label">TOTAL ENERGY TRADED</div>
            <div class="card-value">
              {{ display(topStats.totalEnergyTraded) }}<span class="unit">kWh</span>
            </div>
          </div>
        </div>

        <div class="stat-card">
          <div class="card-icon green-bg-icon">
            <div class="rupee-icon">₹</div>
          </div>
          <div class="card-info">
            <div class="card-label">TOTAL CBDC TRANSACTION</div>
            <div class="card-value">{{ display(topStats.totalCbdcTransaction) }}</div>
          </div>
        </div>
      </div>

      <!-- ─── Bottom Stats ────────────────────────────────────────────── -->
      <div class="bottom-stats-grid">
        <div class="large-card participant-card">
          <div class="card-header">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                 stroke="#107954" stroke-width="2.5"
                 stroke-linecap="round" stroke-linejoin="round">
              <line x1="18" y1="20" x2="18" y2="10"/>
              <line x1="12" y1="20" x2="12" y2="4"/>
              <line x1="6" y1="20" x2="6" y2="14"/>
            </svg>
            <h2 class="section-title">PARTICIPANT STATISTICS</h2>
          </div>
          <div class="participant-split">
            <div class="split-box blue-box">
              <div class="box-content">
                <div class="box-label">Buyers</div>
                <div class="box-value">{{ display(participantStats.buyers) }}</div>
              </div>
              <div class="character-container">
                <img src="assets/image-1.svg" alt="Buyer" class="character-img buyer-img" />
              </div>
            </div>
            <div class="split-box yellow-box">
              <div class="box-content">
                <div class="box-label">Sellers</div>
                <div class="box-value">{{ display(participantStats.sellers) }}</div>
              </div>
              <div class="character-container">
                <img src="assets/image-2.svg" alt="Seller" class="character-img seller-img" />
              </div>
            </div>
          </div>
        </div>

        <div class="large-card active-card">
          <div class="card-header">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                 stroke="#107954" stroke-width="2.5"
                 stroke-linecap="round" stroke-linejoin="round">
              <rect x="2" y="3" width="20" height="14" rx="2" ry="2"/>
              <line x1="8" y1="21" x2="16" y2="21"/>
              <line x1="12" y1="17" x2="12" y2="21"/>
              <path d="M7 10l3 3 7-7"/>
            </svg>
            <h2 class="section-title">ACTIVE PARTICIPANTS STATISTICS</h2>
          </div>
          <div class="active-participant-split">
            <div class="split-column blue-column">
              <div class="column-title">PREFERENTIAL</div>
              <div class="stat-row">
                <div class="row-left">
                  <svg class="row-icon-svg" viewBox="0 0 24 24" fill="none"
                       stroke="currentColor" stroke-width="2.2"
                       stroke-linecap="round" stroke-linejoin="round">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                    <circle cx="12" cy="7" r="4"/>
                  </svg>
                  <span>Buyer</span>
                </div>
                <div class="row-right">{{ display(activeParticipantStats.preferential.buyer) }}</div>
              </div>
              <div class="stat-row">
                <div class="row-left">
                  <svg class="row-icon-svg green-icon" viewBox="0 0 24 24" fill="none"
                       stroke="currentColor" stroke-width="2.2"
                       stroke-linecap="round" stroke-linejoin="round">
                    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
                    <polyline points="9 22 9 12 15 12 15 22"/>
                  </svg>
                  <span>Seller</span>
                </div>
                <div class="row-right">{{ display(activeParticipantStats.preferential.seller) }}</div>
              </div>
            </div>

            <div class="split-column yellow-column">
              <div class="column-title">DYNAMIC</div>
              <div class="stat-row">
                <div class="row-left">
                  <svg class="row-icon-svg" viewBox="0 0 24 24" fill="none"
                       stroke="currentColor" stroke-width="2.2"
                       stroke-linecap="round" stroke-linejoin="round">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                    <circle cx="12" cy="7" r="4"/>
                  </svg>
                  <span>Buyer</span>
                </div>
                <div class="row-right">{{ display(activeParticipantStats.dynamic.buyer) }}</div>
              </div>
              <div class="stat-row">
                <div class="row-left">
                  <svg class="row-icon-svg green-icon" viewBox="0 0 24 24" fill="none"
                       stroke="currentColor" stroke-width="2.2"
                       stroke-linecap="round" stroke-linejoin="round">
                    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
                    <polyline points="9 22 9 12 15 12 15 22"/>
                  </svg>
                  <span>Seller</span>
                </div>
                <div class="row-right">{{ display(activeParticipantStats.dynamic.seller) }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <!--Footer -->
    <div class="dashboard-footer">
      Powered By Hygge Energy
    </div>
    </div>

  </div>